"use client"

import clsx from "clsx"
import { useRef, useState } from "react"
import { NpStaticTooltip } from "src/components/np-design/sections/image/NpStaticTooltip"
import { useWindowEvent } from "src/hooks/useWindowEvent"

export type NpStaticTooltipLayerItemProps = {
  percentLeft: number
  percentTop: number
  text: string
}

export type NpStaticTooltipLayerProps = {
  tooltips: NpStaticTooltipLayerItemProps[]
}

export const NpStaticTooltipLayer = ({ tooltips }: NpStaticTooltipLayerProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const handleClick = (index: number) => {
    setActiveIndex(activeIndex === index ? -1 : index)
  }

  const ref = useRef<HTMLDivElement>(null)
  useWindowEvent("click", (event) => {
    const target = event.target as HTMLElement

    if (!ref.current?.contains(target) || target.tagName !== "BUTTON") {
      setActiveIndex(-1)
    }
  })

  return (
    <div ref={ref} className="absolute inset-0 z-1">
      {tooltips.map((tooltip, index) => {
        const openSide = tooltip.percentLeft > 50 ? "left" : "right"

        return (
          <div
            key={index}
            className={clsx("absolute -translate-y-4", {
              "translate-x-4": openSide === "left",
              "-translate-x-4": openSide === "right",
            })}
            style={{
              top: `${tooltip.percentTop}%`,
              left: openSide === "left" ? undefined : `${tooltip.percentLeft}%`,
              right: openSide === "right" ? undefined : `${100 - tooltip.percentLeft}%`,
            }}
          >
            <NpStaticTooltip expanded={index === activeIndex} onClick={() => handleClick(index)} openSide={openSide}>
              {tooltip.text}
            </NpStaticTooltip>
          </div>
        )
      })}
    </div>
  )
}
